export default __webpack_public_path__ + "static/media/icon-edit-profile.35eaf5c8.svg";